// Libraries Imports
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { useNavigate, useParams } from "react-router-dom";

// Constants, Themes, Images imports
import { REPORT_LIST } from "./constants";

// Components Imports
import RestaurantHeader from "../../../components/RestaurantHeader";
import Container from "../../../components/Container";

const SalesReport = () => {
    const navigate = useNavigate();
    const restId = useParams().rest_id;

    const handleReportClick = (link) => () => {
        navigate(`/restaurant/${restId}/sales${link}`);
    }

    return (
        <Container
            page={"restaurants"}
            searchVal={""}
            onSearch={() => null}
            searchLabel=""
        >
            <Grid container item xs={12}>
                <Grid item xs={12} mb={2}>
                    <RestaurantHeader
                        title={"Sales Report"}
                        onBackBtnClick={() => navigate(`/restaurant/${restId}`)}
                    />
                </Grid>
                <Grid container item xs={12} mb={2} gap={2} justifyContent={"center"} color="pink">
                    {REPORT_LIST.map((x, i) => {
                        return (
                            <Grid item xs={6} md={4} lg={3} key={i} sx={styles.reportContainer}>
                                <Card
                                    sx={styles.reportCard}
                                    onClick={handleReportClick(x.href)}
                                >
                                    {x.icon}
                                    <Typography ml={1} sx={styles.itemText}>
                                        {x.label}
                                    </Typography>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            </Grid>
        </Container>
    );
};

export default SalesReport;

const styles = {
    reportContainer: {
        marginTop: "1.5rem",
        maxWidth: "22rem",
    },
    reportCard: {
        cursor: "pointer",
        borderRadius: 3,
        display: 'flex',
        justifyContent: 'center',
        padding: '2rem',
    },
    itemText: {
        color: "#000000!important",
        fontSize: "0.875rem, !important",
        textAlign: "center",
        fontWeight: 300,
    },
}
